module.exports = __webpack_public_path__ + "70de04b46e9768e5785f3aa0aa4451f3.MP3";